module.exports = __webpack_public_path__ + "img/ry_2.2f8b5c31.png";